import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { LOGOUT_REASON_STATE_KEY, LogoutReason } from './logout-reason';

@Injectable({ providedIn: 'root' })
export class SessionTerminationService {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly router = inject(Router);

  private terminating = false;

  get isTerminating(): boolean {
    return this.terminating;
  }

  // No limpia el storage: la app sigue montada detrás del modal y el header/navbar
  // hacen getCurrentCustomer().id sin guarda. Limpiar acá los revienta en cada CD.
  begin(options: { revoke?: boolean } = {}): boolean {
    if (this.terminating) return false;
    this.terminating = true;
    if (options.revoke) this.authenticationService.revokeSession().subscribe();
    return true;
  }

  end(reason?: LogoutReason, options: { revoke?: boolean } = {}): void {
    this.begin(options);
    const extras = reason ? { state: { [LOGOUT_REASON_STATE_KEY]: reason } } : {};
    this.authenticationService.logout();
    this.router.navigate(['/login'], extras).finally(() => (this.terminating = false));
  }
}
